/**
 * Bridged cW* registry (public EVM chains). Source: cross-chain-pmm-lps/config/deployment-status.json
 * Re-import or sync when addresses change.
 */
import raw from '../../../cross-chain-pmm-lps/config/deployment-status.json';

export type DeploymentStatus = typeof raw;

export const deploymentStatus: DeploymentStatus = raw;

export function listCwChains(): Array<{
  chainId: string;
  name: string;
  tokens: Array<{ symbol: string; address: string }>;
}> {
  const out: Array<{
    chainId: string;
    name: string;
    tokens: Array<{ symbol: string; address: string }>;
  }> = [];
  const chains = deploymentStatus.chains as Record<
    string,
    { name: string; cwTokens: Record<string, string> }
  >;
  for (const [chainId, row] of Object.entries(chains)) {
    const tokens = Object.entries(row.cwTokens || {}).map(([symbol, address]) => ({
      symbol,
      address,
    }));
    if (tokens.length === 0) continue;
    out.push({ chainId, name: row.name, tokens });
  }
  return out.sort((a, b) => Number(a.chainId) - Number(b.chainId));
}
